if (!customElements.get('notification-banner')) {
  customElements.define(
    'notification-banner',
    class NotificationBanner extends HTMLElement {
      constructor() {
        super();
        this._checkCookie();
        this._addEventListener();
      }

      _checkCookie() {
        const content = this._getContent();
        const cookie = document.cookie.split(';').find((item) => item.includes('notificationBanner'));
        if (cookie && cookie.split('=')[1] === content) {
          this.remove();
        } else {
          this.classList.remove('hidden');
        }
      }

      _addEventListener() {
        this.querySelector('.js-close').addEventListener('click', this._handleCloseButtonClick);
      }

      _getContent() {
        return this.querySelector('.js-content').innerHTML.trim();
      }

      _handleCloseButtonClick = () => {
        const content = this._getContent();
        document.cookie = `notificationBanner=${content};max-age=86400`;
        this.remove();
      };
    }
  );
}
